import Model from './model'

export default class Share extends Model {
    /**
     *
     * @returns {string}
     */
    resource() {
        return 'web-api/share'
    }
}
